import { render, staticRenderFns } from "./LocationSummaryLegend.vue?vue&type=template&id=58079c83&"
import script from "./LocationSummaryLegend.vue?vue&type=script&lang=js&"
export * from "./LocationSummaryLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58079c83')) {
      api.createRecord('58079c83', component.options)
    } else {
      api.reload('58079c83', component.options)
    }
    module.hot.accept("./LocationSummaryLegend.vue?vue&type=template&id=58079c83&", function () {
      api.rerender('58079c83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/location-summary/LocationSummaryLegend.vue"
export default component.exports